import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  min-height: 100vh;
  background-color: #f4f0ec;

  align-items: center;
  justify-content: center;
  padding: 24px 30px;
`;

export const Content = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 400px;

  .logo {
    width: 120px;
    margin-bottom: 8px;
  }

  .animation-wrapper {
    margin: 8px 0;
  }

  .description {
    color: #666666;
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 32px;
    padding: 0 8px;
  }
`;

export const Title = styled.h1`
  font-size: 72px;
  font-weight: 700;
  color: #ff6900;
  line-height: 1;
  margin: 0 0 8px;
  letter-spacing: -2px;
`;

export const Subtitle = styled.h2`
  font-size: 26px;
  font-weight: 600;
  color: #202020;
  margin: 0 0 16px;
`;

export const HomeButton = styled(Link)`
  display: inline-block;
  background-color: #ff6900;
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 600;
  padding: 14px 32px;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #e05d00;
    text-decoration: none !important;
  }
`;
